export enum SignUpEvents {
  AccountInfoConfirmClick = 'signup_account_info_confirm_tap',
}
